import { createAction, props } from '@ngrx/store';
import { IEmpleo, ICreateEmpleo, IDeleteEmpleoResponse, IUpdateEmpleo, IUpdateEmpleoResponse } from '../../interfaces/empleos.interface';

export const GetEmpleos = createAction(
    '[Empleos] Get Empleos',
  );

export const GetEmpleosSuccess = createAction(
    '[Empleos] Get Empleos Success',
    props<{empleos: IEmpleo[]}>()
  );

export const CreateEmpleo = createAction(
    '[Empleos] Create Empleo',
    props<{empleo: ICreateEmpleo}>()
  );

export const CreateEmpleoSuccess = createAction(
    '[Empleos] Create Empleos Success',
    props<{empleo: IEmpleo}>()
  );

export const DeleteEmpleo = createAction(
    '[Empleos] Delete Empleo',
    props<{id: string}>()
  );

export const DeleteEmpleoSuccess = createAction(
    '[Empleos] Delete Empleo Success',
    props<{empleo: IDeleteEmpleoResponse}>()
  );

export const UpdateEmpleo = createAction(
    '[Empleos] Update Empleo',
    props<{id: string, empleo: IUpdateEmpleo}>()
  );

export const UpdateEmpleoSuccess = createAction(
    '[Empleos] Update Empleo Success',
    props<{empleo: IUpdateEmpleoResponse}>()
  );
